export default __webpack_public_path__ + "static/media/screens_experiences.9a35a473.png";